const percent = (data, type, total) => {
  if(data[total] === 0) {
    return 0;
  }
  return Math.round(1000 * data[type] / data[total])/10
}

export const profileTips =  userData => [
  {
    name: 'Safe ' + percent(userData, 'total_safe', 'total_tips') + '%',
    value: userData.total_safe,
    fill: "#0BD11E"
  },
  {
    name: 'Regular ' + percent(userData, 'total_regular', 'total_tips') + '%',
    value: userData.total_regular,
    fill: "#0B4AD1"
  },
  {
    name: 'Risky ' + percent(userData, 'total_risky', 'total_tips') + '%',
    value: userData.total_risky,
    fill: "#D12E0B"
  },
]

export const successTips = userData => [
  {
    name: 'Safe ' + percent(userData, 'success_safe', 'total_safe') + '%',
    value: percent(userData, 'success_safe', 'total_safe'),
    fill: "#0BD11E"
  },
  {
    name: 'Regular ' + percent(userData, 'success_regular', 'total_regular') + '%',
    value: percent(userData, 'success_regular', 'total_regular'),
    fill: "#0B4AD1"
  },
  {
    name: 'Risky ' + percent(userData, 'success_risky', 'total_risky') + '%',
    value: percent(userData, 'success_risky', 'total_risky'),
    fill: "#D12E0B"
  },
]

export const profileTotal = userData => [
  {
    name: 'Safe',
    total: userData.total_safe,
    success: userData.success_safe,
    percent: percent(userData, 'success_safe', 'total_safe')
  },
  {
    name: 'Regular',
    total: userData.total_regular,
    success: userData.success_regular,
    percent: percent(userData, 'success_regular', 'total_regular')
  },
  {
    name: 'Risky',
    total: userData.total_risky,
    success: userData.success_risky,
    percent: percent(userData, 'success_risky', 'total_risky')
  },
  {
    name: 'Total',
    total: userData.total_tips,
    success: userData.success_total,
    percent: percent(userData, 'success_total', 'total_tips')
  }
]

